import React, { useState, useEffect } from "react";

import './../PopUp.css';
import './CreationTime.css';

import { RegisterModalData, RegisterModalObserver, SetModalState } from "../../../interface/PopUp";

interface CreationTimeData {
    ReturnProjectFinish : (nameProject: string, logo: string, linkProject: string) => void;
    onlyClose           : boolean;
    name_project        : string;
    logo                : string;
    link_project        : string;
    counterCreation     : number;

    // Texto acima do contador. Sem ele fica a frase do projeto, que era a
    // unica tela que usava este popup.
    message?            : string;
}

export default function PopUp_CreationTime() {

    const [ modalData, setModaldata ] = useState<CreationTimeData>({} as CreationTimeData);
    const [ showPopUp, setShowPopUp ] = useState(false);

    const [ counter, setCounter ] = useState(0);

    useEffect(()=>{
        RegisterModalData('CreationTime', setModaldata);
        RegisterModalObserver('CreationTime', setShowPopUp);
    }, []);

    useEffect(()=>{
        if(!showPopUp) return;

        setCounter(modalData.counterCreation);

        const IntervalCounter = setInterval(() => {
            setCounter(prev => {
                if(prev <= 1){
                    clearInterval(IntervalCounter);

                    if(modalData.ReturnProjectFinish){
                        modalData.ReturnProjectFinish(modalData.name_project, modalData.logo, modalData.link_project);
                    }
                    SetModalState('CreationTime', false);
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);

        return ()=>{ clearInterval(IntervalCounter); };
    }, [showPopUp]);

    return(
        (showPopUp ?
            <div className="PopUp PopUpCenter">
                <div className="all CreationTime">
                    <div className="div_data">
                        <div className="content">
                            { modalData.message ?? 'The project creation will be finalized in' }
                            <div className="counter">
                                { counter }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        : <React.Fragment></React.Fragment>)
    )
}
